function rgb(hex) {
  const value = String(hex || '').replace('#', '')
  if (!/^[0-9a-f]{6}$/i.test(value)) return '96, 165, 250'
  return [0, 2, 4].map(index => parseInt(value.slice(index, index + 2), 16)).join(', ')
}

export function getRoleStyles(workflow) {
  const colors = workflow.theme?.colors || {}
  return {
    '--wv-all': colors.all || '#60A5FA',
    '--wv-employee': colors.employee || '#10B981',
    '--wv-contractor': colors.contractor || '#D946EF',
    '--wv-all-rgb': rgb(colors.all),
    '--wv-employee-rgb': rgb(colors.employee),
    '--wv-contractor-rgb': rgb(colors.contractor)
  }
}
